import React from 'react';
import './ToggleSwitch.css'; // Create this CSS file

export default function ToggleSwitch({ label, value, onChange, className = '' }) {
  return (
    <label className={`switch-container ${className}`.trim()}>
      <span className="switch-label">{label}</span>
      <label className="switch">
        <input
          type="checkbox"
          checked={value}
          onChange={e => onChange(e.target.checked)}
        />
        <span className="slider round"></span>
      </label>
    </label>
  );
}
